
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"object-fit":"cover"},style,staticStyle],
              attrs: Object.assign({"style":"object-fit:cover","version":"1","baseProfile":"full","viewBox":"0 0 1920 865","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h1920v865H0z"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"0","x2":"0","y1":"1","y2":"0"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#2255ff90"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#021e5190"}})])]),_c('path',{staticClass:"transition-all duration-300 ease-in-out delay-150",staticStyle:{"transform-origin":"center"},attrs:{"d":"M0 865V0v758h514V553h410v197h482V605h514v260z","fill":"url(#a)"}}),_c('path',{staticClass:"transition-all duration-300 ease-in-out delay-150",staticStyle:{"transform-origin":"center"},attrs:{"d":"M0 865V0v908-51h553v138h471V741h346v167h550v-43z","fill":"url(#a)"}})])
          )
        }
      }
    